export const globalQueryKeys = {
  files: ['files'],
  partnersConnections: ['partnersConnections'],
  partnersInvitations: ['partnersInvitations'],
};
